import { getSize } from '@/utils/iterable/getSize';
import { posthog } from '@/utils/tracking/posthog';

import { AI_ATTRIBUTE_EVENT, DESTINATION_TO_ATTRIBUTE } from '@/constants/ai';
import { OPERATIONS } from '@/constants/bulkEdit';
import { ATTRIBUTE } from '@/constants/attributes';

export function trackAiOperations({ channel, operations, shopId }) {
  if (!OPERATIONS[channel].AI) return;

  function forEachOperaiton(operation) {
    switch (operation.type) {
      case OPERATIONS[channel].AI: {
        const destination = operation.value.destination_field;
        const attribute = DESTINATION_TO_ATTRIBUTE[destination] || destination;

        switch (attribute) {
          case ATTRIBUTE.TAGS: {
            posthog.track({
              additional_instructions: !!operation.value.input.instructions,
              event: AI_ATTRIBUTE_EVENT[ATTRIBUTE.TAGS][operation.value.operation],
              listings_count: getSize(operation.products),
              page: 'bulk_edit',
              shopId,
              source_component: 'attribute_optimization',
            });

            posthog.track({
              event: AI_ATTRIBUTE_EVENT[ATTRIBUTE.TAGS].KEEP,
              listings_count: getSize(operation.products),
              page: 'bulk_edit',
              shopId,
              source_component: 'attribute_optimization',
            });

            break;
          }

          default: {
            if (!AI_ATTRIBUTE_EVENT[attribute]) break;

            posthog.track({
              additional_instructions: !!operation.value.input.instructions,
              event: AI_ATTRIBUTE_EVENT[attribute].OPTIMIZE,
              listings_count: getSize(operation.products),
              page: 'bulk_edit',
              shopId,
              source_component: 'attribute_optimization',
            });

            posthog.track({
              event: AI_ATTRIBUTE_EVENT[attribute].KEEP,
              listings_count: getSize(operation.products),
              page: 'bulk_edit',
              shopId,
              source_component: 'attribute_optimization',
            });

            break;
          }
        }

        break;
      }

      default: {
        break;
      }
    }
  }

  operations.forEach(forEachOperaiton);
}
